<template>
    <div>
        <div class="wrapper">
          <nav>
            <input type="radio" name="tab" id="home" value="1" v-on:click="tabchange" checked>
            <input type="radio" name="tab" id="inbox" value="2" v-on:click="tabchange">
            <input type="radio" name="tab" id="contact" value="3" v-on:click="tabchange">
            <input type="radio" name="tab" id="heart" value="4" v-on:click="tabchange">
            <input type="radio" name="tab" id="about" value="5" v-on:click="tabchange">
            <label for="home" class="home press" style="font-size: 16px;">班级</label>
            <label for="inbox" class="inbox press" style="font-size: 16px;">学员</label>
            <label for="contact" class="contact press" style="font-size: 16px;">课程</label>
            <label for="heart" class="heart press" style="font-size: 16px;">实况</label>
            <label for="about" class="about press" style="font-size: 16px;">作业</label>
            <div class="tab">
            </div>
          </nav>
        </div>
        <hr class="pad-top">
    </div>
</template>

<script>
    export default {
        name: "AppBar",
        data () {
          return {

          }

        },
        methods :{
            tabchange(event){
                this.$emit("clicked",event.target.defaultValue);
            }
        }
    }
</script>

<style scoped>

  body {
    font-family: Source Han Sans CN;
    font-size: 16px;
    font-weight: 400;
    margin: 0;
  }

  .navmenu {
    position: fixed;
    top: 0;
    width: 240px;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 7px 0px 35px 0px rgba(205, 205, 205, 0.18);
    z-index: 3;
  }

  a:link {
    color: #EDB903;
    text-decoration: none;
  }

  a:visited {
    color: #EDB903;
    text-decoration: none;

  }

  a:hover {
    color: #EDB903;
    text-decoration: none;
  }

  a:active {
    color: #EDB903;
    text-decoration: none;
  }

  .titlebar {
    top: 0;
    position: fixed;
    left: 0px;
    width: 100%;
    background: linear-gradient(90deg, #049DE5, #0171A3);
    height: 123px;
    display: flex;
    justify-content: flex-end;
    z-index: 2;
  }

  .titlebar2 {
    top: 111px;
    position: absolute;
    left: 0px;
    width: 100%;
    background: linear-gradient(90deg, #049DE5, #0171A3);
    height: 123px;
    display: flex;
    justify-content: flex-end;
    z-index: -1;
  }

  .main {
    position: relative;
    background: #FFFFFF;
    box-shadow: 0px 10px 28px 1px rgba(179, 187, 190, 0.18);
    border-radius: 20px;
    margin-right: 30px;
    margin-left: 270px;
    margin-top: 123px;
    padding-bottom: 30px;
    z-index: 1;
  }

  .logo {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #logo-img {
    margin-top: 17px;
    width: 79px;
    height: 71px;
    background: #FFFFFF;
    border-radius: 50%;
    display: block;
  }

  #logo-cn {
    width: 71px;
    height: 22px;
    font-size: 23px;
    font-family: Source Han Sans CN;
    padding: 0;
  }

  #logo-en {
    width: 71px;
    height: 7px;
    font-size: 11px;
    font-family: High Tower Text;
    font-weight: 400;
    color: #373737;
    padding: 0;
    margin-top: 8px;
    margin-bottom: 25px;
  }

  .menu-item {
    padding: 22px 0 22px 0;
  }

  .menu-item :hover {
    color: #0171A3;
  }

  .menu-item-inside {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 39px;
    margin-right: 98px;
  }

  .menu-icon {
    width: 18px;
    height: 18px;
  }

  .alert-icon {
    display: flex;
    height: 50px;
    width: 50px;
    margin-top: 35px;
    margin-right: 20px;
    align-items: center;
    justify-content: center;
  }

  .alert-icon img {
    height: 31px;
  }

  .account-icon {
    display: flex;
    height: 50px;
    width: 140px;
    margin-top: 35px;
    margin-right: 55px;
    align-items: center;
    color: white;
    font-size: 18px;
  }

  .account-icon img {
    height: 31px;
    margin-right: 10px;
  }

  .new-icon {
    position: relative;
    background-color: red;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    top: -15px;
    left: -10px;
  }

  .search-condition {
    position: relative;
    padding-top: 28px;
    margin: 5px 30px 5px 30px;
  }

  .search-condition hr {
    position: relative;
    top: 6px;
  }

  .search-condition-pulldown {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: space-between;
  }


  .search-condition-pulldown select option {
    height: 34px;
    border-radius: 5px 5px 0px 0px;
  }

  .search-condition-pulldown select option:hover {

    background: #0171A3;
  }

  .search-condition-pulldown label {
    color: #333333;
    width: 50px;
    text-align: right;
    margin: 0 10px 0 20px;
  }

  .search-condition-date-range {
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .search-condition-date-range label:nth-of-type(1) {
    color: #333333;
    width: 100px;
    text-align: right;
    margin: 0 10px 0 20px;
  }

  .search-condition-date-range label:nth-of-type(2) {
    color: #333333;
    text-align: right;
    margin: 0 10px 0 10px;
  }

  .search-condition-date-range input {
    width: 220px;
    height: 42px;
    background: #FFFFFF;
    border: 1px solid #DEE2E6;
    border-radius: 5px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    padding-left: 10px;
    padding-right: 10px;
  }

  .search-condition-text {
    display: flex;
    position: relative;
    justify-content: flex-start;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .search-condition-text label:nth-of-type(1) {
    color: #333333;
    width: 100px;
    text-align: right;
    margin: 0 10px 0 20px;
  }

  .search-condition-text input {
    width: 215px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #DEE2E6;
    border-radius: 5px;
    padding-left: 8px;
    padding-right: 8px;
    margin: 12px 0 12px 0;
  }

  .search-condition-button div {
    width: 88px;
    height: 38px;
    background: #EDB903;
    border-radius: 5px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px 20px 12px 20px;
  }

  .wrapper {
    height: 25px;
    width: 60%;
    position: relative;
  }

  .wrapper nav {
    position: relative;
    display: flex;
  }

  .wrapper nav label {
    flex: 1;
    width: 100%;
    z-index: 1;
    padding-bottom: 15px;
    text-align: center;
  }

  .wrapper nav .press {
    cursor: pointer;
  }

  .wrapper nav label a {
    position: relative;
    z-index: -1;
    color: #1d1f20;
    font-size: 20px;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.6s ease;
  }

  .wrapper nav label a i {
    font-size: 25px;
    margin: 0 7px;
  }

  .wrapper nav .tab {
    position: absolute;
    height: 3px;
    width: 20%;
    left: 0;
    bottom: 0;
    z-index: 0;
    border-radius: 50px;
    background: #0171A3;
    transition: 0.2s;
  }

  .wrapper nav #inbox:checked~.tab {
    left: 20%;
  }

  .wrapper nav #contact:checked~.tab {
    left: 40%;
  }

  .wrapper nav #heart:checked~.tab {
    left: 60%;
  }

  .wrapper nav #about:checked~.tab {
    left: 80%;
  }

  .wrapper nav input {
    display: none;
  }



  .switch {
    position: relative;
    display: inline-block;
    width: 55px;
    height: 30px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 30px;
    width: 30px;
    left: 0px;
    box-shadow: 0px 1px 5px 0px rgba(2, 44, 63, 0.44);
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  input:checked+.slider {
    background: #0171A3;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #2196F3;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .button {
    display: flex;
    width: 124px;
    height: 46px;
    background: #0171A3;
    border-radius: 5px;
    color: #FEFEFE;
    justify-content: center;
    align-items: center;
    margin: 5px;
  }
  .pad-top {
    margin-top: 14px;
  }
</style>